<mat-nav-list>
  <h2 matSubheader>Página inicial</h2>
  <a mat-list-item routerLink="/home">
    <mat-icon matListIcon class="nav-list-icon">home</mat-icon>
    Coleta
  </a>
  <!-- <a mat-list-item *ngIf="isAdmin" routerLink="/users">
        <mat-icon matListIcon class="nav-list-icon">person</mat-icon>
        Usuários
    </a> -->

  <br />
  <h2 matSubheader>Documentos</h2>
  <a mat-list-item (click)="openManual()">
    <mat-icon matListIcon class="nav-list-icon">chrome_reader_mode</mat-icon>
    <span class="ml-1">Manual do credenciado</span>
  </a>
  <a mat-list-item (click)="openExames()">
    <mat-icon matListIcon class="nav-list-icon">chrome_reader_mode</mat-icon>
    <span class="ml-1">Exames do pacientes</span>
  </a>
  <a mat-list-item (click)="openContrato()">
    <mat-icon matListIcon class="nav-list-icon">chrome_reader_mode</mat-icon>
    <span class="ml-1">Contrato do cliente</span>
  </a>
  <a mat-list-item (click)="openPrecos()">
    <mat-icon matListIcon class="nav-list-icon">chrome_reader_mode</mat-icon>
    <span class="ml-1">Tabela de preços</span>
  </a>

  <br />
  <h2 matSubheader>Configurações</h2>

  <!-- <a mat-list-item routerLink="/configuracoes/dados-cadastrais">
        <mat-icon matListIcon class="nav-list-icon">view_headline</mat-icon>
        Dados Cadastrais
    </a> -->
  <a mat-list-item routerLink="/configuracoes/alterar-senha">
    <mat-icon matListIcon class="nav-list-icon">vpn_key</mat-icon>
    Alterar senha
  </a>
  <a mat-list-item (click)="logout()">
    <mat-icon class="nav-list-icon">exit_to_app</mat-icon>
    <span class="ml-1">Sair</span>
  </a>
  <!-- <a mat-list-item>
        <mat-icon matListIcon class="nav-list-icon">table_chart</mat-icon>
        Centro custo
    </a> -->
  <!--
    <h2 matSubheader>Cracha</h2>
    <a mat-list-item routerLink="/cracha/funcionarios">
        <mat-icon matListIcon class="nav-list-icon">insert_photo</mat-icon>
        Funcionarios
    </a>
    <a mat-list-item routerLink="/cracha/visitantes">
        <mat-icon matListIcon class="nav-list-icon">insert_photo</mat-icon>
        Visitantes
    </a>
   -->
</mat-nav-list>
